import { CITIZENSHIP_INFO  } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(CITIZENSHIP_INFO)
